import { useAppSelector } from './useAppSelector'

export default useAppSelector
